import React from 'react'
import { Pressable, StyleSheet, Text, View } from 'react-native'
import { DS } from '@/design-system'
import { translate } from '../../../i18n'

const TURN_CLOCK_OPTIONS = [20, 30, 40]

interface TurnClockPickerProps {
  value: number
  onChange: (seconds: number) => void
}

export function TurnClockPicker({ value, onChange }: TurnClockPickerProps) {
  return (
    <View style={styles.container}>
      {TURN_CLOCK_OPTIONS.map((seconds) => {
        const selected = seconds === value
        return (
          <Pressable
            key={seconds}
            onPress={() => onChange(seconds)}
            style={[styles.pill, selected && styles.pillSelected]}
          >
            <Text style={[styles.label, selected && styles.labelSelected]}>
              {translate('createGameV2.secondsCount', { count: seconds })}
            </Text>
          </Pressable>
        )
      })}
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    gap: 8
  },
  pill: {
    flex: 1,
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: 50,
    borderWidth: 1,
    borderColor: DS.palette['Brand/Light Grey'],
    alignItems: 'center'
  },
  pillSelected: {
    backgroundColor: DS.palette['Global/Black']
  },
  label: {
    fontSize: 14,
    color: DS.palette['Global/Black']
  },
  labelSelected: {
    color: DS.palette['Global/White']
  }
})
